import { Button, Dialog, DialogBody, DialogContent, DialogFooter, Label } from '@civilgrid/ui/components';

export type EditNotesDialogProps = {
  open: boolean;
  onClose: () => void;
  notes: string;
  onNotesChange: (value: string) => void;
  onSubmit: () => void;
  isPending: boolean;
  title: string;
  label: string;
};

export function EditNotesDialog({
  open,
  onClose,
  notes,
  onNotesChange,
  onSubmit,
  isPending,
  title,
  label,
}: EditNotesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-testid="civilsearch-bulk-edit-notes-dialog"
        title={title}
        preventDismiss={notes !== ''}
        className="w-120"
      >
        <DialogBody className="flex flex-col gap-2 w-full">
          <Label>{label}</Label>
          <textarea
            value={notes}
            onChange={(e) => onNotesChange(e.target.value)}
            rows={6}
            placeholder="Text to append to notes..."
            className="w-full rounded-md border border-grey-30 bg-transparent px-3 py-2 text-sm resize-none focus:outline-none focus:border-focus"
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit} disabled={isPending}>
            {isPending ? 'Updating…' : 'Update'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
